// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "onboarding_session".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { onboardingContentSourceValues, onboardingSessionStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "onboarding_session" table (1:1 with a DB row, on the wire). */
export const onboardingSessionAtomSchema = z.object({
    id: z.string(),
    userId: z.string(),
    organizationId: z.string().nullable(),
    status: z.enum(onboardingSessionStatusValues),
    currentSlide: z.string(),
    answers: z.unknown().nullable(),
    conversationTurns: z.unknown().nullable(),
    websiteUrl: z.string().nullable(),
    analysisJobId: z.string().nullable(),
    analysisResult: z.unknown().nullable(),
    contentSource: z.enum(onboardingContentSourceValues).nullable(),
    contentBatchId: z.string().nullable(),
    selectedServiceId: z.string().nullable(),
    servicePriceCents: z.number().nullable(),
    offerId: z.string().nullable(),
    adCandidateGraphicIds: z.unknown().nullable(),
    selectedGraphicIds: z.unknown().nullable(),
    videoCandidateIds: z.unknown().nullable(),
    selectedVideoId: z.string().nullable(),
    stagedCampaign: z.unknown().nullable(),
    metaCampaignId: z.string().nullable(),
    launchedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=onboardingSession.js.map